export default __webpack_public_path__ + "static/media/OnlineConsultationIcon.6bd34551.svg";